import apiClient from '@/services/axios'

export async function del(payload) {
  var response = await apiClient.delete('/content/' + payload.contentFileId)
  if (response) {
    return response.data
  }

  throw new Error('Unable to delete File.')
}